export default defineNuxtPlugin(() => {
  globalThis.$fetch = globalThis.$fetch.create({
    onResponseError({ response }) {
      if (response.status === 403) {
        console.log('request forbidden')
        reloadNuxtApp()
      }
    },
  })
})
